module.exports = __webpack_public_path__ + "static/media/market-place.614287b1.jpg";